import ButtonDefault from 'ui/src/buttons/ButtonDefault'
import TooltipDefault from 'ui/src/tooltip/TooltipDefault'
import InputText from 'ui/src/inputs/InputText'
import InputTextArea from 'ui/src/inputs/InputTextArea'
import InputSelect from 'ui/src/inputs/InputSelect'
import InputRadio from 'ui/src/inputs/InputRadio'
import InputCheckBox from 'ui/src/inputs/InputCheckBox'
import styles from 'ui/src/styles/components/parts/Input.module.scss'
import { useEffect, useState } from 'react'
import { useLocale } from '@/features/i18n/hooks/useLocale'
import { apiUrls } from '@/libs/apiUrls'
import { useAuth } from '@/components/providers/AuthProvider'

interface Props {
  className?: string
  isOpen?: boolean
  data?: any
  onClose?: () => void
  deleteAction: () => void
}

export default function TableModalConfirmDelete({
  className,
  isOpen,
  data,
  onClose,
  deleteAction,
}: Props) {
  const { t } = useLocale()
  const { token, tUser } = useAuth()

  const submitAction = () => {
    deleteAction?.()
    onClose?.()
  }

  return (
    <>
      <table className="mb-5">
        <tbody></tbody>
      </table>
      <div className="flex gap-5 justify-center">
        <ButtonDefault label={t.button.Cancel} color="secondary" action={onClose} />
        <ButtonDefault label={t.button.Delete} color="primary" action={submitAction} />
      </div>
    </>
  )
}
